class PageQueryStore {
    public updateSystem(name: string, searchParams: URLSearchParams) {
        const buffer:any = {}
        Array.from(searchParams.keys()).filter(e => [
            'page'
        ].indexOf(e) === -1).forEach(key => {
            const val = searchParams.getAll(key) || undefined
            if (val) {
                buffer[key] = val
            }
        })
        if (Object.keys(buffer).length) {
            this.update(name, buffer)
        }
    }

    public restore(
        name: string,
        searchParams: URLSearchParams,
        setSearchParams: (searchParams: URLSearchParams) => any,
        defaultParams?: any
    ) {
        if (Array.from(searchParams.keys()).length) {
            return undefined
        }
        const stored = pageQueryStore.retrieve(name) || defaultParams
        if (!stored) {
            return
        }

        Object.keys(stored).forEach(key => {
            const v = stored[key]
            searchParams.delete(key)
            if (v) {
                if (v instanceof Array) {
                    v.forEach(v => searchParams.append(key, v))
                } else {
                    searchParams.set(key, v)
                }
            }

        })

        this.clear(name)
        window.setTimeout(() => {
            setSearchParams(searchParams)
        }, 100)
    }

    public clear(key: string) {
        localStorage.removeItem(key)
    }

    public has(key: string): boolean {
        return Boolean(localStorage.getItem(key))
    }

    private update(key: string, val: any) {
        if (!val) {
            localStorage.removeItem(key)
        } else {
            localStorage.setItem(key, JSON.stringify(val))
        }
    }

    private retrieve(key: string): any | undefined {
        const value = localStorage.getItem(key)
        if (value) {
            return JSON.parse(value)
        }
    }
}

const pageQueryStore = new PageQueryStore()

export {
    pageQueryStore
}
